import React from 'react';
import ProjectOversightLayout from './projectOversight/ProjectOversightLayout';

const ProjectReports = () => <ProjectOversightLayout mode="report" />;

export default ProjectReports;
